// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-book-page {
  min-height: calc(100vh - 64px);
  background-color: #121212;
  padding: 12px;
}

.recipe-book-container {
  max-width: none;
  margin: 0 auto;
}

/* HEADER */
.recipe-book-header {
  margin-bottom: 12px;
}

.recipe-book-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.recipe-book-title-row h1 {
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.create-book-section {
  background: #1e1e1e;
  padding: 10px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* MAIN LAYOUT */
.recipe-book-main {
  width: 100%;
}

/* CONTENT AREA */
.recipe-book-content {
  background: #1e1e1e;
  border-radius: 8px;
  padding: 4px;
  overflow-y: auto;
  max-height: calc(100vh - 140px);
}

/* ===== RECIPE KEEPER STYLE ===== */

/* Search bar */
.rk-search-bar {
  margin-bottom: 16px;
}

/* Home view - category grid */
.rk-home-view {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

.rk-category-card {
  background: var(--panel-bg);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
  display: flex;
  flex-direction: column;
}

.rk-category-card:hover {
  transform: translateY(-3px);
  border-color: var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 10px rgba(165, 243, 176, 0.4);
}

.rk-cat-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #3a3a3a;
}

.rk-cat-icon {
  font-size: 20px;
  color: #4caf50;
}

.rk-cat-name {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rk-cat-count {
  background: #444;
  color: #aaa;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
}

.rk-cat-caption {
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.rk-cat-image-single {
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: #1e1e1e;
  position: relative;
}

.rk-cat-image-single img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.5s ease;
}

/* When an image fails to load, show a subtle placeholder icon */
.rk-cat-image-single.rk-image-broken {
  display: flex;
  align-items: center;
  justify-content: center;
}

.rk-cat-image-single.rk-image-broken:after {
  content: '\\f2e7';
  font-family: 'Font Awesome 6 Free';
  font-weight: 900;
  font-size: 2.5rem;
  color: rgba(255, 255, 255, 0.2);
}

/* Blur-up pattern for category card images */
.rk-cat-image-single .rk-image-blur-up {
  width: 100%;
  height: 100%;
}

.rk-cat-image-single .rk-image-thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(8px);
  transition: filter 0.4s ease-out, opacity 0.4s ease-out;
}

.rk-cat-image-single .rk-image-full {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.4s ease-out;
}

.rk-cat-image-single .rk-image-full.loaded {
  opacity: 1;
}

.rk-cat-image-single .rk-image-full.loaded ~ .rk-image-thumb {
  opacity: 0;
}

.rk-cat-images {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 4px;
  padding: 4px;
  min-height: 120px;
}

.rk-cat-image-tile {
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 6px;
  background: #1e1e1e;
}

.rk-cat-image-tile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.rk-cat-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
}

.rk-cat-empty {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
  min-height: 120px;
}

/* Category view & search view */
.rk-category-view, .rk-search-view {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rk-view-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
}

.rk-view-title {
  flex: 1 1;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.rk-action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Recipe list (list view) */
.rk-recipe-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

.rk-recipe-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: var(--panel-bg);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
  aspect-ratio: 1 / 1;
  min-width: 0;
}

.rk-recipe-item:hover {
  background: #2a2a2a;
  border-color: var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

.rk-recipe-image {
  width: 100%;
  height: 60%;
  flex-shrink: 0;
  overflow: hidden;
  background: #1e1e1e;
  position: relative;
}

.rk-image-chips {
  position: absolute;
  bottom: 4px;
  left: 4px;
  right: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  z-index: 1;
}

.rk-image-chips .difficulty-badge {
  font-size: 8px;
  padding: 1px 5px;
  background: rgba(0, 0, 0, 0.7);
}

.rk-time-chip {
  font-size: 8px;
  padding: 1px 5px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 6px;
  white-space: nowrap;
}

.rk-recipe-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Blur-up image loading effect */
.rk-image-blur-up {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.rk-image-thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(10px);
  opacity: 1;
  transition: opacity 0.4s ease;
  z-index: 1;
}

.rk-image-full {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(0px);
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 2;
}

.rk-image-full.loaded {
  opacity: 1;
}

.rk-image-blur-up:hover .rk-image-thumb {
  filter: blur(0px);
}

.rk-recipe-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
}

.rk-recipe-info {
  flex: 1 1;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  overflow: hidden;
}

.rk-recipe-title {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.3;
}

.rk-recipe-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: #aaa;
  flex-wrap: wrap;
}

.rk-recipe-cats {
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
}

.rk-cat-tag {
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
}

.rk-empty-state {
  text-align: center;
  color: #666;
  font-size: 15px;
  padding: 40px 20px;
}

/* Pagination */
.rk-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 12px 0;
}

.rk-page-indicator {
  color: #888;
  font-size: 13px;
}

/* ===== END RECIPE KEEPER ===== */

/* LEGACY STYLES (kept for compatibility) */
.recipe-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.category-grid-section {
  background: #181818;
  border-radius: 8px;
  padding: 12px;
}

.grid-section-title {
  color: #aaa;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 0 4px 8px;
  border-bottom: 1px solid #333;
  margin-bottom: 10px;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
}

.category-grid-card {
  background: #2a2a2a;
  border-radius: 8px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  border-bottom: 3px solid transparent;
  position: relative;
}

.category-grid-card:hover {
  background: #333;
  transform: translateY(-2px);
}

.category-grid-card.active {
  background: #333;
  border-bottom-color: #4caf50;
}

.card-icon {
  font-size: 24px;
  opacity: 0.8;
}

.card-name {
  color: #ddd;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.card-count {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #444;
  color: #999;
  font-size: 11px;
  padding: 2px 7px;
  border-radius: 10px;
}

.category-grid-card.active .card-count {
  background: #4caf50;
  color: #fff;
}

/* MAIN RECIPE AREA */
.recipe-main-area {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.search-bar {
  background: #181818;
  padding: 8px 12px;
  border-radius: 8px;
}

.search-bar .MuiOutlinedInput-root {
  background: #222;
  border-radius: 6px;
}

/* PAGINATION CONTROLS */
.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 8px 0;
}

.page-indicator {
  color: #888;
  font-size: 13px;
  min-width: 120px;
  text-align: center;
}

.empty-book-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #666;
}

.empty-book-state p {
  margin-top: 16px;
  font-size: 16px;
}

/* BOOK DROPDOWN HEADER */
.book-dropdown-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.inline-new-book-form {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.inline-new-book-form .MuiTextField-root {
  min-width: 150px;
}

.book-header-actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

/* BOOK EDIT INLINE */
.book-edit-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

/* SHARED USERS */
.shared-users-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.shared-user-chip {
  background: #333;
  color: #ccc;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.remove-shared {
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #f44336;
  margin-left: 2px;
  line-height: 1;
}

.remove-shared:hover {
  color: #ff6659;
}

/* RECIPE ACTIONS */
.recipe-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.recipe-actions h2 {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.recipe-count-label {
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
}

.recipe-action-buttons {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

/* RECIPE LIST (legacy) */
.recipe-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 6px;
}

/* RECIPE CARD - Square like Recipe Keeper */
.recipe-card {
  background: var(--panel-bg);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
  transition: border-color 0.2s, transform 0.15s, box-shadow 0.2s;
  aspect-ratio: 1 / 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.recipe-card:hover {
  border-color: var(--wire-green);
  transform: translateY(-1px);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

.recipe-card-image {
  flex: 2 1;
  position: relative;
  overflow: hidden;
  background: #1e1e1e;
}

.recipe-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recipe-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
}

.recipe-card-cat-overlay {
  position: absolute;
  bottom: 4px;
  left: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  max-width: calc(100% - 8px);
}

.recipe-category-tag {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 5px;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}

.recipe-card-body {
  flex: 1 1;
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.recipe-card-title {
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  margin: 0 0 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.2;
}

.recipe-card-footer {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 8px;
  color: #aaa;
  flex-wrap: wrap;
}

.recipe-card-footer .recipe-time {
  font-size: 7px;
}

.recipe-card-footer .difficulty-badge {
  font-size: 7px;
}

/* DIFFICULTY BADGE */
.difficulty-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 9px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
}

/* SEARCH & FILTER BAR */
.search-filter-bar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #333;
}

.category-filter-scroll {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 2px 0;
  scrollbar-width: thin;
  scrollbar-color: #555 #1e1e1e;
}

.category-filter-scroll::-webkit-scrollbar {
  height: 6px;
}

.category-filter-scroll::-webkit-scrollbar-track {
  background: #1e1e1e;
  border-radius: 3px;
}

.category-filter-scroll::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 3px;
}

.category-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid var(--wire-green);
  border-radius: 20px;
  background: var(--panel-bg);
  color: #ccc;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
}

.category-chip:hover {
  background: #2a2a2a;
  border-color: var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

.category-chip.active {
  background: #1e1e1e;
  border-color: var(--wire-green);
  color: #fff;
  font-weight: 600;
}

/* RECIPE CATEGORIES */
.recipe-categories {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.recipe-category-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid;
}

/* MODAL CATEGORY GRID */
.modal-category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.category-select-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 8px;
  border: 1px solid var(--wire-green);
  border-radius: 10px;
  background: var(--panel-bg);
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
}

.category-select-chip:hover {
  background: #2a2a2a;
  border-color: var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

.category-select-chip.selected {
  border-color: var(--wire-green);
  background: #1e1e1e;
}

.category-icon {
  font-size: 24px;
}

.category-label {
  font-size: 11px;
  color: #ccc;
  text-align: center;
}

.check-mark {
  position: absolute;
  top: 4px;
  right: 6px;
  color: #4caf50;
  font-size: 14px;
  font-weight: bold;
}

/* LOADING */
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .rk-home-view {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
  .rk-recipe-list {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
}

@media (max-width: 600px) {
  .rk-home-view {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 6px;
  }

  .rk-category-card {
    border-radius: 6px;
  }

  .rk-cat-image-single {
    aspect-ratio: 1 / 1;
  }

  .rk-cat-caption {
    padding: 4px 6px;
  }

  .rk-cat-name {
    font-size: 10px;
  }

  .rk-cat-count {
    font-size: 8px;
  }

  .rk-recipe-list {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }

  .rk-recipe-item {
    flex-direction: column;
  }

  .rk-recipe-image {
    width: 100%;
    height: 55%;
  }

  .rk-recipe-info {
    padding: 4px 6px;
  }

  .rk-recipe-title {
    font-size: 10px;
  }

  .rk-cat-tag {
    font-size: 7px;
  }

  .rk-image-chips {
    bottom: 2px;
    left: 2px;
    right: 2px;
    gap: 2px;
  }

  .rk-image-chips .difficulty-badge,
  .rk-time-chip {
    font-size: 7px;
    padding: 1px 4px;
  }
}

/* ============================================
   SEARCH TOGGLE & ACTION BAR
   ============================================ */
.rk-search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.rk-search-toggle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #3a3a3a;
  background: #2a2a2a;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.rk-search-toggle:hover {
  background: #3a3a3a;
  border-color: #555;
}

.rk-action-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.rk-add-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--wire-green);
  background: var(--btn-bg);
  color: var(--wire-green);
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  margin-left: auto;
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
}

.rk-add-btn:hover {
  background: var(--btn-bg-hover);
  color: #fff;
  transform: scale(1.1);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

/* ============================================
   ADD/IMPORT MENU OVERLAY
   ============================================ */
.rk-add-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.rk-add-menu {
  background: #1e1e1e;
  border-radius: 12px 12px 0 0;
  padding: 20px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rk-add-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: none;
  background: #2a2a2a;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;
  text-align: left;
  width: 100%;
}

.rk-add-menu-item:hover {
  background: #3a3a3a;
}

.rk-add-menu-item svg {
  font-size: 16px;
  opacity: 0.7;
}

@media (max-width: 600px) {
  .rk-add-btn {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
  
  .rk-search-toggle {
    width: 36px;
    height: 36px;
  }
}

/* ============================================
   HEADER ACTIONS (search + add buttons)
   ============================================ */
.book-dropdown-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.rk-header-actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.rk-search-bar-expanded {
  margin-bottom: 12px;
}

.rk-search-bar-expanded .MuiOutlinedInput-root {
  background: #2a2a2a;
}

/* HEADER BOOK DROPDOWN - for the AppBar header */
.header-book-select .MuiNativeSelect-select {
  padding: 6px 24px 6px 12px;
  color: #fff;
  background: transparent;
}

.header-book-select .MuiOutlinedInput-notchedOutline {
  border-color: rgba(255, 255, 255, 0.3);
}

.header-book-select .MuiOutlinedInput-notchedOutline:hover {
  border-color: rgba(255, 255, 255, 0.5);
}

.header-book-select .MuiSvgIcon-root {
  color: #fff;
}

/* Header action buttons - lighter for AppBar */
.header-rk-search-toggle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.header-rk-search-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.header-rk-add-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--wire-green);
  background: var(--btn-bg);
  color: var(--wire-green);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
}

.header-rk-add-btn:hover {
  background: var(--btn-bg-hover);
  color: #fff;
  transform: scale(1.1);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

@media (max-width: 768px) {
  .header-rk-search-toggle {
    width: 20px;
    height: 20px;
    font-size: 8px;
  }

  .header-rk-search-toggle svg {
    font-size: 8px !important;
  }

  .header-rk-add-btn {
    width: 20px;
    height: 20px;
    font-size: 8px;
  }

  .header-rk-add-btn svg {
    font-size: 8px !important;
  }

  .header-book-select {
    min-width: 90px !important;
    font-size: 12px !important;
  }

  .toolbar {
    padding-left: 4px !important;
    padding-right: 4px !important;
    min-height: 40px !important;
  }

  .toolbar .MuiTypography-root {
    font-size: 13px !important;
  }

  .toolbar .MuiButton-root {
    font-size: 11px !important;
    padding: 2px 8px !important;
  }

  .rk-edit-ingredient-row {
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .rk-edit-ingredient-row .MuiTextField-root {
    width: 100% !important;
  }

  .rk-recipe-page .MuiTextField-root {
    font-size: 14px !important;
  }
}

/* ===== ALL BOOKS LIST VIEW (Progressive Loading) ===== */
.rk-all-books-list {
  width: 100%;
}
.rk-all-books-list::-webkit-scrollbar { width: 6px; }
.rk-all-books-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 3px; }
.rk-all-books-list::-webkit-scrollbar-track { background: transparent; }
.rk-list-header { display: flex; align-items: center; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.1); margin-bottom: 12px; }
.rk-list-count { color: rgba(255,255,255,0.6); font-size: 13px; }
.rk-list-items { display: flex; flex-direction: column; gap: 0; }
.rk-list-item { display: flex; align-items: stretch; padding: 10px 12px; border-radius: 8px; cursor: pointer; transition: background-color 0.2s ease; }
.rk-list-item:hover { background-color: rgba(255,255,255,0.05); }
.rk-list-item:active { background-color: rgba(255,255,255,0.08); }
.rk-list-item-image { flex-shrink: 0; width: 72px; height: 72px; border-radius: 6px; overflow: hidden; position: relative; }
.rk-list-item-image .rk-image-blur-up { width: 100%; height: 100%; }
.rk-list-item-image .rk-image-thumb { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; filter: blur(8px); transition: filter 0.4s ease-out, opacity 0.4s ease-out; }
.rk-list-item-image .rk-image-full { position: relative; width: 100%; height: 100%; object-fit: cover; opacity: 0; transition: opacity 0.4s ease-out; }
.rk-list-item-image .rk-image-full.loaded { opacity: 1; }
.rk-list-item-image .rk-image-full.loaded ~ .rk-image-thumb { opacity: 0; }
.rk-list-placeholder { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.3); font-size: 20px; }
.rk-list-item-info { flex: 1 1; padding-left: 14px; display: flex; flex-direction: column; justify-content: center; min-width: 0; gap: 4px; }
.rk-list-item-title { margin: 0; color: #fff; font-size: 15px; font-weight: 500; line-height: 1.3; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rk-list-book-name { font-size: 12px; color: rgba(255,255,255,0.5); }
.rk-list-item-meta { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
@media (max-width: 768px) {
  .rk-list-item { padding: 8px; }
  .rk-list-item-image { width: 56px; height: 56px; }
  .rk-list-item-title { font-size: 14px; }
  .rk-list-item-info { padding-left: 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeBook/RecipeBook.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,oCAAoC;;AAEpC,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mCAAmC;EACnC,qDAAqD;EACrD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,uHAAuH;AACzH;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,wFAAwF;AAC1F;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,kCAAkC;;AAElC,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,qDAAqD;EACrD,+DAA+D;EAC/D,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,eAAe;EACf,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,wFAAwF;AAC1F;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,wFAAwF;AAC1F;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,4DAA4D;EAC9D;EACA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,UAAU;IACV,QAAQ;EACV;;EAEA;;IAEE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,qBAAqB;EACrB,wFAAwF;AAC1F;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,0BAA0B;EAC1B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,qBAAqB;EACrB,wFAAwF;AAC1F;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,0DAA0D;AAC1D;EACE,WAAW;AACb;AACA,wCAAwC,UAAU,EAAE;AACpD,8CAA8C,kCAAkC,EAAE,kBAAkB,EAAE;AACtG,8CAA8C,uBAAuB,EAAE;AACvE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,eAAe,EAAE,8CAA8C,EAAE,mBAAmB,EAAE;AAC5K,iBAAiB,4BAA4B,EAAE,eAAe,EAAE;AAChE,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;AAChE,gBAAgB,aAAa,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,sCAAsC,EAAE;AACtJ,sBAAsB,wCAAwC,EAAE;AAChE,uBAAuB,wCAAwC,EAAE;AACjE,sBAAsB,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC3H,wCAAwC,WAAW,EAAE,YAAY,EAAE;AACnE,sCAAsC,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,uDAAuD,EAAE;AACrM,qCAAqC,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,UAAU,EAAE,iCAAiC,EAAE;AACtJ,4CAA4C,UAAU,EAAE;AACxD,8DAA8D,UAAU,EAAE;AAC1E,uBAAuB,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kCAAkC,EAAE,4BAA4B,EAAE,eAAe,EAAE;AAClM,qBAAqB,SAAO,EAAE,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,YAAY,EAAE,QAAQ,EAAE;AAC1I,sBAAsB,SAAS,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACnK,qBAAqB,eAAe,EAAE,4BAA4B,EAAE;AACpE,qBAAqB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACpF;EACE,gBAAgB,YAAY,EAAE;EAC9B,sBAAsB,WAAW,EAAE,YAAY,EAAE;EACjD,sBAAsB,eAAe,EAAE;EACvC,qBAAqB,kBAAkB,EAAE;AAC3C","sourcesContent":[".recipe-book-page {\n  min-height: calc(100vh - 64px);\n  background-color: #121212;\n  padding: 12px;\n}\n\n.recipe-book-container {\n  max-width: none;\n  margin: 0 auto;\n}\n\n/* HEADER */\n.recipe-book-header {\n  margin-bottom: 12px;\n}\n\n.recipe-book-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.recipe-book-title-row h1 {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.create-book-section {\n  background: #1e1e1e;\n  padding: 10px 14px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* MAIN LAYOUT */\n.recipe-book-main {\n  width: 100%;\n}\n\n/* CONTENT AREA */\n.recipe-book-content {\n  background: #1e1e1e;\n  border-radius: 8px;\n  padding: 4px;\n  overflow-y: auto;\n  max-height: calc(100vh - 140px);\n}\n\n/* ===== RECIPE KEEPER STYLE ===== */\n\n/* Search bar */\n.rk-search-bar {\n  margin-bottom: 16px;\n}\n\n/* Home view - category grid */\n.rk-home-view {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px;\n}\n\n.rk-category-card {\n  background: var(--panel-bg);\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n  display: flex;\n  flex-direction: column;\n}\n\n.rk-category-card:hover {\n  transform: translateY(-3px);\n  border-color: var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n.rk-cat-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-bottom: 1px solid #3a3a3a;\n}\n\n.rk-cat-icon {\n  font-size: 20px;\n  color: #4caf50;\n}\n\n.rk-cat-name {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rk-cat-count {\n  background: #444;\n  color: #aaa;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 10px;\n}\n\n.rk-cat-caption {\n  padding: 8px 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rk-cat-image-single {\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n  background: #1e1e1e;\n  position: relative;\n}\n\n.rk-cat-image-single img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.5s ease;\n}\n\n/* When an image fails to load, show a subtle placeholder icon */\n.rk-cat-image-single.rk-image-broken {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rk-cat-image-single.rk-image-broken:after {\n  content: '\\f2e7';\n  font-family: 'Font Awesome 6 Free';\n  font-weight: 900;\n  font-size: 2.5rem;\n  color: rgba(255, 255, 255, 0.2);\n}\n\n/* Blur-up pattern for category card images */\n.rk-cat-image-single .rk-image-blur-up {\n  width: 100%;\n  height: 100%;\n}\n\n.rk-cat-image-single .rk-image-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: blur(8px);\n  transition: filter 0.4s ease-out, opacity 0.4s ease-out;\n}\n\n.rk-cat-image-single .rk-image-full {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.4s ease-out;\n}\n\n.rk-cat-image-single .rk-image-full.loaded {\n  opacity: 1;\n}\n\n.rk-cat-image-single .rk-image-full.loaded ~ .rk-image-thumb {\n  opacity: 0;\n}\n\n.rk-cat-images {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\n  gap: 4px;\n  padding: 4px;\n  min-height: 120px;\n}\n\n.rk-cat-image-tile {\n  aspect-ratio: 1;\n  overflow: hidden;\n  border-radius: 6px;\n  background: #1e1e1e;\n}\n\n.rk-cat-image-tile img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.rk-cat-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #555;\n}\n\n.rk-cat-empty {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #666;\n  font-size: 14px;\n  min-height: 120px;\n}\n\n/* Category view & search view */\n.rk-category-view, .rk-search-view {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rk-view-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #333;\n}\n\n.rk-view-title {\n  flex: 1;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.rk-action-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Recipe list (list view) */\n.rk-recipe-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px;\n}\n\n.rk-recipe-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: var(--panel-bg);\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: 1px solid var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n  aspect-ratio: 1 / 1;\n  min-width: 0;\n}\n\n.rk-recipe-item:hover {\n  background: #2a2a2a;\n  border-color: var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n.rk-recipe-image {\n  width: 100%;\n  height: 60%;\n  flex-shrink: 0;\n  overflow: hidden;\n  background: #1e1e1e;\n  position: relative;\n}\n\n.rk-image-chips {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  right: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  z-index: 1;\n}\n\n.rk-image-chips .difficulty-badge {\n  font-size: 8px;\n  padding: 1px 5px;\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.rk-time-chip {\n  font-size: 8px;\n  padding: 1px 5px;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.rk-recipe-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Blur-up image loading effect */\n.rk-image-blur-up {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.rk-image-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: blur(10px);\n  opacity: 1;\n  transition: opacity 0.4s ease;\n  z-index: 1;\n}\n\n.rk-image-full {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: blur(0px);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  z-index: 2;\n}\n\n.rk-image-full.loaded {\n  opacity: 1;\n}\n\n.rk-image-blur-up:hover .rk-image-thumb {\n  filter: blur(0px);\n}\n\n.rk-recipe-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #555;\n}\n\n.rk-recipe-info {\n  flex: 1;\n  padding: 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.rk-recipe-title {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.3;\n}\n\n.rk-recipe-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: #aaa;\n  flex-wrap: wrap;\n}\n\n.rk-recipe-cats {\n  display: flex;\n  gap: 3px;\n  flex-wrap: wrap;\n}\n\n.rk-cat-tag {\n  padding: 2px 6px;\n  border-radius: 8px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.rk-empty-state {\n  text-align: center;\n  color: #666;\n  font-size: 15px;\n  padding: 40px 20px;\n}\n\n/* Pagination */\n.rk-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 12px 0;\n}\n\n.rk-page-indicator {\n  color: #888;\n  font-size: 13px;\n}\n\n/* ===== END RECIPE KEEPER ===== */\n\n/* LEGACY STYLES (kept for compatibility) */\n.recipe-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.category-grid-section {\n  background: #181818;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.grid-section-title {\n  color: #aaa;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  padding: 0 4px 8px;\n  border-bottom: 1px solid #333;\n  margin-bottom: 10px;\n}\n\n.category-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 10px;\n}\n\n.category-grid-card {\n  background: #2a2a2a;\n  border-radius: 8px;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border-bottom: 3px solid transparent;\n  position: relative;\n}\n\n.category-grid-card:hover {\n  background: #333;\n  transform: translateY(-2px);\n}\n\n.category-grid-card.active {\n  background: #333;\n  border-bottom-color: #4caf50;\n}\n\n.card-icon {\n  font-size: 24px;\n  opacity: 0.8;\n}\n\n.card-name {\n  color: #ddd;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.card-count {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #444;\n  color: #999;\n  font-size: 11px;\n  padding: 2px 7px;\n  border-radius: 10px;\n}\n\n.category-grid-card.active .card-count {\n  background: #4caf50;\n  color: #fff;\n}\n\n/* MAIN RECIPE AREA */\n.recipe-main-area {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.search-bar {\n  background: #181818;\n  padding: 8px 12px;\n  border-radius: 8px;\n}\n\n.search-bar .MuiOutlinedInput-root {\n  background: #222;\n  border-radius: 6px;\n}\n\n/* PAGINATION CONTROLS */\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 8px 0;\n}\n\n.page-indicator {\n  color: #888;\n  font-size: 13px;\n  min-width: 120px;\n  text-align: center;\n}\n\n.empty-book-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n  color: #666;\n}\n\n.empty-book-state p {\n  margin-top: 16px;\n  font-size: 16px;\n}\n\n/* BOOK DROPDOWN HEADER */\n.book-dropdown-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #333;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.inline-new-book-form {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.inline-new-book-form .MuiTextField-root {\n  min-width: 150px;\n}\n\n.book-header-actions {\n  display: flex;\n  gap: 6px;\n  margin-left: auto;\n}\n\n/* BOOK EDIT INLINE */\n.book-edit-inline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 0;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n/* SHARED USERS */\n.shared-users-bar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 0;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.shared-user-chip {\n  background: #333;\n  color: #ccc;\n  padding: 4px 10px;\n  border-radius: 16px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.remove-shared {\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  color: #f44336;\n  margin-left: 2px;\n  line-height: 1;\n}\n\n.remove-shared:hover {\n  color: #ff6659;\n}\n\n/* RECIPE ACTIONS */\n.recipe-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.recipe-actions h2 {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.recipe-count-label {\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.recipe-action-buttons {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n/* RECIPE LIST (legacy) */\n.recipe-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 6px;\n}\n\n/* RECIPE CARD - Square like Recipe Keeper */\n.recipe-card {\n  background: var(--panel-bg);\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n  transition: border-color 0.2s, transform 0.15s, box-shadow 0.2s;\n  aspect-ratio: 1 / 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.recipe-card:hover {\n  border-color: var(--wire-green);\n  transform: translateY(-1px);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n.recipe-card-image {\n  flex: 2;\n  position: relative;\n  overflow: hidden;\n  background: #1e1e1e;\n}\n\n.recipe-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.recipe-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #555;\n}\n\n.recipe-card-cat-overlay {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  max-width: calc(100% - 8px);\n}\n\n.recipe-category-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 5px;\n  border-radius: 8px;\n  font-size: 8px;\n  font-weight: 600;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.recipe-card-body {\n  flex: 1;\n  padding: 6px 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-width: 0;\n}\n\n.recipe-card-title {\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.2;\n}\n\n.recipe-card-footer {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 8px;\n  color: #aaa;\n  flex-wrap: wrap;\n}\n\n.recipe-card-footer .recipe-time {\n  font-size: 7px;\n}\n\n.recipe-card-footer .difficulty-badge {\n  font-size: 7px;\n}\n\n/* DIFFICULTY BADGE */\n.difficulty-badge {\n  display: inline-block;\n  padding: 1px 6px;\n  border-radius: 8px;\n  font-size: 9px;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n}\n\n/* SEARCH & FILTER BAR */\n.search-filter-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid #333;\n}\n\n.category-filter-scroll {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding: 2px 0;\n  scrollbar-width: thin;\n  scrollbar-color: #555 #1e1e1e;\n}\n\n.category-filter-scroll::-webkit-scrollbar {\n  height: 6px;\n}\n\n.category-filter-scroll::-webkit-scrollbar-track {\n  background: #1e1e1e;\n  border-radius: 3px;\n}\n\n.category-filter-scroll::-webkit-scrollbar-thumb {\n  background: #555;\n  border-radius: 3px;\n}\n\n.category-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border: 1px solid var(--wire-green);\n  border-radius: 20px;\n  background: var(--panel-bg);\n  color: #ccc;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s;\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n}\n\n.category-chip:hover {\n  background: #2a2a2a;\n  border-color: var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n.category-chip.active {\n  background: #1e1e1e;\n  border-color: var(--wire-green);\n  color: #fff;\n  font-weight: 600;\n}\n\n/* RECIPE CATEGORIES */\n.recipe-categories {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n\n.recipe-category-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid;\n}\n\n/* MODAL CATEGORY GRID */\n.modal-category-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.category-select-chip {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 8px;\n  border: 1px solid var(--wire-green);\n  border-radius: 10px;\n  background: var(--panel-bg);\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n}\n\n.category-select-chip:hover {\n  background: #2a2a2a;\n  border-color: var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n.category-select-chip.selected {\n  border-color: var(--wire-green);\n  background: #1e1e1e;\n}\n\n.category-icon {\n  font-size: 24px;\n}\n\n.category-label {\n  font-size: 11px;\n  color: #ccc;\n  text-align: center;\n}\n\n.check-mark {\n  position: absolute;\n  top: 4px;\n  right: 6px;\n  color: #4caf50;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/* LOADING */\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n}\n\n/* RESPONSIVE */\n@media (max-width: 900px) {\n  .rk-home-view {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  }\n  .rk-recipe-list {\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  }\n}\n\n@media (max-width: 600px) {\n  .rk-home-view {\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n    gap: 6px;\n  }\n\n  .rk-category-card {\n    border-radius: 6px;\n  }\n\n  .rk-cat-image-single {\n    aspect-ratio: 1 / 1;\n  }\n\n  .rk-cat-caption {\n    padding: 4px 6px;\n  }\n\n  .rk-cat-name {\n    font-size: 10px;\n  }\n\n  .rk-cat-count {\n    font-size: 8px;\n  }\n\n  .rk-recipe-list {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  }\n\n  .rk-recipe-item {\n    flex-direction: column;\n  }\n\n  .rk-recipe-image {\n    width: 100%;\n    height: 55%;\n  }\n\n  .rk-recipe-info {\n    padding: 4px 6px;\n  }\n\n  .rk-recipe-title {\n    font-size: 10px;\n  }\n\n  .rk-cat-tag {\n    font-size: 7px;\n  }\n\n  .rk-image-chips {\n    bottom: 2px;\n    left: 2px;\n    right: 2px;\n    gap: 2px;\n  }\n\n  .rk-image-chips .difficulty-badge,\n  .rk-time-chip {\n    font-size: 7px;\n    padding: 1px 4px;\n  }\n}\n\n/* ============================================\n   SEARCH TOGGLE & ACTION BAR\n   ============================================ */\n.rk-search-bar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.rk-search-toggle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid #3a3a3a;\n  background: #2a2a2a;\n  color: #fff;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.rk-search-toggle:hover {\n  background: #3a3a3a;\n  border-color: #555;\n}\n\n.rk-action-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.rk-add-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid var(--wire-green);\n  background: var(--btn-bg);\n  color: var(--wire-green);\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  margin-left: auto;\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n}\n\n.rk-add-btn:hover {\n  background: var(--btn-bg-hover);\n  color: #fff;\n  transform: scale(1.1);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n/* ============================================\n   ADD/IMPORT MENU OVERLAY\n   ============================================ */\n.rk-add-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 1000;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.rk-add-menu {\n  background: #1e1e1e;\n  border-radius: 12px 12px 0 0;\n  padding: 20px;\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.rk-add-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: none;\n  background: #2a2a2a;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background 0.2s;\n  text-align: left;\n  width: 100%;\n}\n\n.rk-add-menu-item:hover {\n  background: #3a3a3a;\n}\n\n.rk-add-menu-item svg {\n  font-size: 16px;\n  opacity: 0.7;\n}\n\n@media (max-width: 600px) {\n  .rk-add-btn {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n  \n  .rk-search-toggle {\n    width: 36px;\n    height: 36px;\n  }\n}\n\n/* ============================================\n   HEADER ACTIONS (search + add buttons)\n   ============================================ */\n.book-dropdown-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.rk-header-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.rk-search-bar-expanded {\n  margin-bottom: 12px;\n}\n\n.rk-search-bar-expanded .MuiOutlinedInput-root {\n  background: #2a2a2a;\n}\n\n/* HEADER BOOK DROPDOWN - for the AppBar header */\n.header-book-select .MuiNativeSelect-select {\n  padding: 6px 24px 6px 12px;\n  color: #fff;\n  background: transparent;\n}\n\n.header-book-select .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.header-book-select .MuiOutlinedInput-notchedOutline:hover {\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.header-book-select .MuiSvgIcon-root {\n  color: #fff;\n}\n\n/* Header action buttons - lighter for AppBar */\n.header-rk-search-toggle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.header-rk-search-toggle:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.header-rk-add-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--wire-green);\n  background: var(--btn-bg);\n  color: var(--wire-green);\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n}\n\n.header-rk-add-btn:hover {\n  background: var(--btn-bg-hover);\n  color: #fff;\n  transform: scale(1.1);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n@media (max-width: 768px) {\n  .header-rk-search-toggle {\n    width: 20px;\n    height: 20px;\n    font-size: 8px;\n  }\n\n  .header-rk-search-toggle svg {\n    font-size: 8px !important;\n  }\n\n  .header-rk-add-btn {\n    width: 20px;\n    height: 20px;\n    font-size: 8px;\n  }\n\n  .header-rk-add-btn svg {\n    font-size: 8px !important;\n  }\n\n  .header-book-select {\n    min-width: 90px !important;\n    font-size: 12px !important;\n  }\n\n  .toolbar {\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n    min-height: 40px !important;\n  }\n\n  .toolbar .MuiTypography-root {\n    font-size: 13px !important;\n  }\n\n  .toolbar .MuiButton-root {\n    font-size: 11px !important;\n    padding: 2px 8px !important;\n  }\n\n  .rk-edit-ingredient-row {\n    flex-direction: column !important;\n    align-items: stretch !important;\n  }\n\n  .rk-edit-ingredient-row .MuiTextField-root {\n    width: 100% !important;\n  }\n\n  .rk-recipe-page .MuiTextField-root {\n    font-size: 14px !important;\n  }\n}\n\n/* ===== ALL BOOKS LIST VIEW (Progressive Loading) ===== */\n.rk-all-books-list {\n  width: 100%;\n}\n.rk-all-books-list::-webkit-scrollbar { width: 6px; }\n.rk-all-books-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 3px; }\n.rk-all-books-list::-webkit-scrollbar-track { background: transparent; }\n.rk-list-header { display: flex; align-items: center; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.1); margin-bottom: 12px; }\n.rk-list-count { color: rgba(255,255,255,0.6); font-size: 13px; }\n.rk-list-items { display: flex; flex-direction: column; gap: 0; }\n.rk-list-item { display: flex; align-items: stretch; padding: 10px 12px; border-radius: 8px; cursor: pointer; transition: background-color 0.2s ease; }\n.rk-list-item:hover { background-color: rgba(255,255,255,0.05); }\n.rk-list-item:active { background-color: rgba(255,255,255,0.08); }\n.rk-list-item-image { flex-shrink: 0; width: 72px; height: 72px; border-radius: 6px; overflow: hidden; position: relative; }\n.rk-list-item-image .rk-image-blur-up { width: 100%; height: 100%; }\n.rk-list-item-image .rk-image-thumb { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; filter: blur(8px); transition: filter 0.4s ease-out, opacity 0.4s ease-out; }\n.rk-list-item-image .rk-image-full { position: relative; width: 100%; height: 100%; object-fit: cover; opacity: 0; transition: opacity 0.4s ease-out; }\n.rk-list-item-image .rk-image-full.loaded { opacity: 1; }\n.rk-list-item-image .rk-image-full.loaded ~ .rk-image-thumb { opacity: 0; }\n.rk-list-placeholder { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.3); font-size: 20px; }\n.rk-list-item-info { flex: 1; padding-left: 14px; display: flex; flex-direction: column; justify-content: center; min-width: 0; gap: 4px; }\n.rk-list-item-title { margin: 0; color: #fff; font-size: 15px; font-weight: 500; line-height: 1.3; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.rk-list-book-name { font-size: 12px; color: rgba(255,255,255,0.5); }\n.rk-list-item-meta { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }\n@media (max-width: 768px) {\n  .rk-list-item { padding: 8px; }\n  .rk-list-item-image { width: 56px; height: 56px; }\n  .rk-list-item-title { font-size: 14px; }\n  .rk-list-item-info { padding-left: 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
